import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import FolderCard from '../FolderCard';
import FolderBar from '../FolderBar';
import FoldersHeader from '../FoldersHeader';
import ErrorBoundary from '@wix/da-shared-react/pkg/ErrorBoundary';
import FolderContent from '../FolderContent';
import { PapiGallection } from '@wix/da-types-papi';
import { MeasuredCookieType } from '@wix/da-shared-react/pkg/Measured';
import Grid, {
  GridElement,
  GridBreakpoint,
} from '@wix/da-shared-react/pkg/Grid';

export const BREAKPOINTS: GridBreakpoint[] = [
  {
    maxWidth: 480,
    elementWidth: 280,
    elementHeight: 250,
  },
  {
    maxWidth: 1024,
    elementWidth: 304,
    elementHeight: 250,
  },
  {
    maxWidth: 1280,
    elementWidth: 389,
    elementHeight: 298,
  },
  {
    maxWidth: 1366,
    elementWidth: 404,
    elementHeight: 306,
  },
  {
    maxWidth: 1920,
    elementWidth: 438,
    elementHeight: 325,
  },
];

export type Props = {
  folders: PapiGallection[];
  selectedFolderId: number | null;
};

class GallectionsGridView extends React.Component<Props & WithTranslation> {
  render() {
    const { selectedFolderId } = this.props;
    if (selectedFolderId) {
      return this.renderSelectedFolderContent();
    }

    return this.renderFolderGrid();
  }

  renderSelectedFolderContent() {
    const { selectedFolderId } = this.props;
    return (
      <div>
        <ErrorBoundary>
          <FolderBar withBackButton={true} />
          <FolderContent scrollIntoViewWhenLoaded folderId={selectedFolderId} />
        </ErrorBoundary>
      </div>
    );
  }

  renderFolderGrid() {
    const { folders } = this.props;

    if (!folders.length) {
      return null;
    }

    return (
      <div>
        <ErrorBoundary>
          <FoldersHeader />
          <Grid
            elementCount={folders.length}
            cookieType={MeasuredCookieType.USER_PROFILE_GALLECTION_CONTENT}
            renderElement={this.renderElement}
            getElementId={this.getItemId}
            breakpoints={BREAKPOINTS}
          />
        </ErrorBoundary>
      </div>
    );
  }

  renderElement = ({ index, style, width, height }: GridElement) => {
    const { folders } = this.props;
    const folder = folders[index];

    return (
      <div key={folder.folderId} style={{ ...style }}>
        <FolderCard
          withViewAllButton
          folder={folder}
          indexInsideParent={index}
          width={width}
          isResponsive={true}
        />
      </div>
    );
  };

  getItemId = (index: number) => {
    const { folders } = this.props;
    const folder = folders[index];
    return `${index}-${folder.folderId}`;
  };
}

export default withTranslation()(GallectionsGridView);
